import React, { useState } from 'react';
import axios from 'axios';
import '../styles/PredictionForm.css';


const fieldOptions = {
    "Yaş": [18, 19, 20, 21, 22, 23, 24, 25],
    "Cinsiyet": ["Kadın", "Erkek"],
    "Sosyoekonomik Düzey": ["Orta", "Yüksek"],
    "Annenin Eğitim Düzeyi": ["Lise", "Üniversite", "Yüksek Lisans"],
    "Babanın Eğitim Düzeyi": ["Lise", "Üniversite", "Yüksek Lisans"],
    "Aile Tutumu": ["Destekleyici", "İlgili"],
    "Arkadaş İlişkisi": ["İyi", "Çok iyi"],
    "Birlikte Yaşadığı Kişi": ["Ailemle", "Arkadaşlarımla"],
    "Aile Tipi": ["Çekirdek"],
    "Aylık Gelir": [0, 500, 1000],
    "Haftalık İnternet Saat": Array.from({ length: 41 }, (_, i) => i),
    "Kişisel Bilgisayar": ["Evet"],
    "Bilgisayar Kullanımı": ["İyi", "Çok iyi"],
    "BİT Kullanım Amacı": ["Araştırma", "Eğitim"],
    "Mobil Araçlar": ["Akıllı telefon", "Tablet"],
    "Tercih Edilen Öğrenme": ["Görsel", "Uygulamalı"],
    "Daha İyi Öğrenme Şekli": ["Görerek", "Uygulama yaparak"],
    "Motivasyon Türü": ["İçsel motivasyon"],
    "VR Faydaları": ["Gerçekçi deneyim sağlar", "Kalıcı öğrenme"],
    "VR Gözlük Yeterli": ["Evet"],
    "VR Güçlük": ["Yok", "Çok az"],
    "Kullanılan VR Senaryo": ["Simülasyon", "Hasta bakımı"],
    "VR Yokluğu Etkisi": ["Kısmen", "Evet"],
    "Lab Yeterliliği": ["Evet", "Kısmen"],
    "Klinik Fark": ["Evet"],
    "VR Olmaması Sonuçları": ["Deneyim kaybı", "Uygulama eksikliği"],
    "Yan Etki": ["Göz yorgunluğu", "Yok"],
    "Diğer Derslerde VR": ["Evet"]
};

const initialState = Object.fromEntries(
    Object.keys(fieldOptions).map(key => [key, fieldOptions[key][0]])
);

function PredictionForm() {
    const [formData, setFormData] = useState(initialState);
    const [result, setResult] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: isNaN(value) ? value : isNaN(Number(value)) ? value : Number(value) }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/prediction/tahmin`, formData);
            setResult(response.data);
        } catch (error) {
            console.error(error);
            setResult("Hata oluştu.");
        }
    };

    return (
        <div className="form-container">
            <h2>Gelişim Tahmin Formu</h2>
            <form onSubmit={handleSubmit}>
                {Object.entries(fieldOptions).map(([field, options]) => (
                    <div key={field} style={{ marginBottom: '1rem' }}>
                        <label>{field}:</label>
                        <select name={field} value={formData[field]} onChange={handleChange}>
                            {options.map(opt => (
                                <option key={opt} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                ))}
                <button type="submit">Tahmin Et</button>
            </form>
            {result && <div style={{ marginTop: '20px', fontWeight: 'bold' }}>Sonuç: {result}</div>}
        </div>
    );
}

export default PredictionForm;
